import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { guestApi } from "@/lib/guest";

export default function TokenBoard() {
  const { slug } = useParams();
  const { data } = useQuery({
    queryKey: ["public-tokens", slug],
    queryFn: async () => (await api.get(guestApi(slug, "/tokens"))).data,
    refetchInterval: 3000,
    enabled: !!slug,
  });
  if (!slug) {
    return (
      <div className="min-h-screen grid place-items-center bg-black text-white p-8 text-center">
        <div>
          <h1 className="font-display text-3xl font-800">Token board needs your restaurant link</h1>
          <p className="text-white/60 mt-2">Open <code>/r/your-slug/tokens</code> from Settings.</p>
        </div>
      </div>
    );
  }
  const preparing = data?.preparing || [];
  const ready = data?.ready || [];

  return (
    <div className="min-h-screen bg-black text-white p-8" data-testid="token-board">
      <div className="text-center mb-8">
        <div className="text-white/50 uppercase tracking-[0.3em] text-sm">Token Management</div>
        <h1 className="font-display text-5xl font-800 mt-2">Now Serving</h1>
      </div>
      <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
        <div>
          <div className="text-[#FF9F0A] text-xl font-semibold mb-4">Preparing</div>
          <div className="grid grid-cols-3 gap-3">
            {preparing.map((o) => (
              <div key={o.id} className="rounded-2xl bg-[#1c1c1e] p-6 text-center">
                <div className="font-display text-4xl font-800">{o.token_number}</div>
                <div className="text-xs text-white/40 mt-1">{o.order_number}</div>
              </div>
            ))}
            {!preparing.length && <div className="text-white/30 col-span-3 py-12 text-center">—</div>}
          </div>
        </div>
        <div>
          <div className="text-[#34C759] text-xl font-semibold mb-4">Ready to collect</div>
          <div className="grid grid-cols-3 gap-3">
            {ready.map((o) => (
              <div key={o.id} className="rounded-2xl bg-[#34C759]/15 border border-[#34C759] p-6 text-center">
                <div className="font-display text-4xl font-800 text-[#34C759]">{o.token_number}</div>
                <div className="text-xs text-white/40 mt-1">{o.order_number}</div>
              </div>
            ))}
            {!ready.length && <div className="text-white/30 col-span-3 py-12 text-center">—</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
